import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';
import './codeblock.scss';

export const CodeBlock = ({ language, code }) => {
  const { copied, copy } = useCopyToClipboard();

  return (
    // Replaced Tailwind classes with semantic CSS classes for SCSS styling
    <div className="code-block-container">
      <div className="code-block-header">
        <div className="code-block-language">{language}</div>
        <button
          onClick={() => copy(code)} // Call the copy function from the hook
          className="copy-button"
          title="Copy to clipboard"
        >
          {copied ? (
            // Checkmark Icon when copied
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="copy-icon check-icon"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
          ) : (
            // Copy Icon
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="copy-icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 002-2V3a2 2 0 00-2-2H9a2 2 0 00-2 2v2m8 4.414l-4 4-4-4"
              />
            </svg>
          )}
          {copied && <span className="copied-message">Copied!</span>}
        </button>
      </div>
      <pre className="code-block-pre">
        <code className={`code-block-code language-${language}`}>{code}</code>
      </pre>
    </div>
  );
};
